import { useQuery } from "@tanstack/react-query";
import { createUrlWithQuery } from "../../../hooks/utils";
import { generateVideoKey } from "../../../react-query/keyFactory";
import { apiClient } from "../../../services/Services";

export default function useDownload(
    deviceId: string,
    time: string,
    enabled = true,
) {
    const queryKey = [...generateVideoKey(deviceId, time), "download"];

    const {
        data: video,
        error,
        ...queryResult
    } = useQuery({
        queryKey,
        queryFn: async (): Promise<Blob> => {
            const response = await apiClient.get<Blob>(
                createUrlWithQuery(`devices/${deviceId}/videos`, {
                    time,
                }),
                {
                    responseType: "blob",
                    headers: {
                        accept: "video/mp4",
                    },
                },
            );
            return response;
        },
        enabled,
    });

    return { video, error, ...queryResult };
}
